import { PerformanceMetrics, TradingAlert } from '../types/dashboard';

/** Raise totalAlerts when overview metrics are 0 but execution history exists (local calendar day). */
export function enrichPerformanceMetricsFromHistory(
  metrics: PerformanceMetrics,
  history: TradingAlert[]
): PerformanceMetrics {
  if (!history.length) {
    return metrics;
  }
  const now = new Date();
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startWeek = new Date(startToday.getTime() - 7 * 24 * 60 * 60 * 1000);
  const startMonth = new Date(startToday.getTime() - 30 * 24 * 60 * 60 * 1000);
  const ts = (a: TradingAlert) => new Date(a.timestamp).getTime();
  const todayN = history.filter((a) => ts(a) >= startToday.getTime()).length;
  const weekN = history.filter((a) => ts(a) >= startWeek.getTime()).length;
  const monthN = history.filter((a) => ts(a) >= startMonth.getTime()).length;

  return {
    ...metrics,
    totalAlerts: {
      today: Math.max(metrics.totalAlerts.today, todayN),
      thisWeek: Math.max(metrics.totalAlerts.thisWeek, weekN),
      thisMonth: Math.max(metrics.totalAlerts.thisMonth, monthN),
    },
  };
}
